/*
 * @Author: Zhouqi
 * @Date: 2025-11-03 10:57:44
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-11 17:56:50
 */
import { useTranslate } from '@/hooks/useTranslate';
import { AIFunction } from '@/utils/const';
import { usePageVisitTrack } from '@/utils/eventlog/logAdapter';

import {
  AvatarVideoCard,
  VideoGenerateCard,
  VideoTranslationCard,
} from './_components/feature-cards';
import PopularTool from './_components/popular-tool';
import SocialUgcAds from './_components/social-ugc-ads';

const Home = () => {
  const { t } = useTranslate();

  usePageVisitTrack(AIFunction.Home);

  return (
    <div className="flex justify-center overflow-y-auto no-scrollbar w-full h-full">
      <div className="flex flex-col gap-[16px] px-[32px] py-[16px] max-w-[1218px] w-full">
        {/* 欢迎标题 */}
        <span className="font-[500] text-[16px] leading-[22px]">{t('FalcoCut')}</span>

        {/* 主要功能卡片 */}
        <div className="flex gap-[16px] w-full">
          <VideoGenerateCard />
          <AvatarVideoCard />
          <VideoTranslationCard />
        </div>

        {/* Popular Tools 标题 */}
        <span className="font-[500] text-[16px] leading-[22px]">
          {t('3e90c5117dc0fe9d71410e448d766e52')}
        </span>

        {/* Popular Tools 列表 */}
        <PopularTool />

        {/* Social & UGC Ads */}
        <SocialUgcAds />
      </div>
    </div>
  );
};

export default Home;
